import {InstallGuide} from './pwa/InstallGuide';
import {NotificationPermissionBanner} from './pwa/NotificationPermissionBanner';
import {UpdateAvailableBanner} from './pwa/UpdateAvailableBanner';
import {MobileNavigationProvider} from '@/contexts/MobileNavigationContext/MobileNavigationContext';
import {Box} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import {useIntercom} from 'react-use-intercom';
import {MobileBottomTabs, TAB_BAR_HEIGHT} from './MobileBottomTabs';
import {MobileHeader, HEADER_HEIGHT} from './MobileHeader';
import {MobileMoreSheet} from './MobileMoreSheet';

const INTERCOM_DEFAULT_VERTICAL_PADDING = 20;
const INTERCOM_MOBILE_VERTICAL_PADDING = TAB_BAR_HEIGHT + 24;

export const MobileLayout = () => {
  const theme = useTheme();
  const {update} = useIntercom();

  useEffect(() => {
    update({verticalPadding: INTERCOM_MOBILE_VERTICAL_PADDING});
    return () => {
      update({verticalPadding: INTERCOM_DEFAULT_VERTICAL_PADDING});
    };
  }, [update]);

  return (
    <MobileNavigationProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100dvh',
          backgroundColor: theme.palette.background.default,
        }}
      >
        <MobileHeader />
        <Box
          id="main-scroll-container"
          sx={{
            flex: 1,
            marginTop: `calc(${HEADER_HEIGHT}px + env(safe-area-inset-top))`,
            marginBottom: `calc(${TAB_BAR_HEIGHT}px + env(safe-area-inset-bottom))`,
            overflowX: 'hidden',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          <InstallGuide />
          <NotificationPermissionBanner />
          <UpdateAvailableBanner />
          <Outlet />
        </Box>
        <MobileBottomTabs />
        <MobileMoreSheet />
      </Box>
    </MobileNavigationProvider>
  );
};
